import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData } from "features/dinamic";

interface AlumnoCicloState {
  status: string;
  error: string;
  ciclos: any[];
  activeCiclo: any | null;
}

const initialState: AlumnoCicloState = {
  status: 'idle',
  error: '',
  ciclos: [],
  activeCiclo: null,
}

export const fetchAlumnoCiclos = createAsyncThunk('alumno/fetchCiclos', async (_: any, { dispatch, getState, rejectWithValue }) => {
  const idsp = 202;
  const { result, message, data } = await getData({ idsp }, getState, dispatch);
  if (result) {
    return { data };
  }
  return rejectWithValue(message);
});

const alumnoCicloSlice = createSlice({
  name: 'alumnoCiclo',
  initialState,
  reducers: {
    setActiveCiclo: (state, action) => {
      state.activeCiclo = action.payload;
    },
    clearCiclos: (state) => {
      state.ciclos = [];
      state.activeCiclo = null;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAlumnoCiclos.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAlumnoCiclos.fulfilled, (state, action) => {
        state.status = 'completed';
        state.ciclos = Array.isArray(action.payload.data) ? action.payload.data : [];
      })
      .addCase(fetchAlumnoCiclos.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      })
  }
});

export const selectAlumnoCiclos = (state: RootState) => state.alumnoCiclo.ciclos;
export const selectAlumnoCicloActive = (state: RootState) => state.alumnoCiclo.activeCiclo;
export const selectAlumnoCicloStatus = (state: RootState) => state.alumnoCiclo.status;

export const { setActiveCiclo, clearCiclos } = alumnoCicloSlice.actions;

export default alumnoCicloSlice.reducer;